// A NAME WITH ITS COUNT, inside its bracket and against the letter: "Barrel nut (G×2)", as a
// sub-step's sentence writes it (see renderSubStepText). After a side word, which is a word, a
// space: "Side rail (C, Left ×1)". A name with no bracket (a piece, "103 - Rear frame") takes it
// after a space.
const split = (label: string, n: number) => {
  const m = /^(.*\()([^()]*)\)$/.exec(label);
  if (!m) return { head: `${label} `, count: `×${n}`, tail: '' };
  const last = m[2].split(', ').pop() ?? '';
  const code = /^[\p{Lu}\d]{1,4}$/u.test(last);
  return { head: `${m[1]}${m[2]}${code ? '' : ' '}`, count: `×${n}`, tail: ')' };
};

export const countedText = (label: string, n: number): string => {
  const { head, count, tail } = split(label, n);
  return `${head}${count}${tail}`;
};

// The same, with the count in bold as the chips draw it.
export function CountedLabel({ label, n }: { label: string; n: number }) {
  const { head, count, tail } = split(label, n);
  return (
    <>
      {head}
      <span className="font-semibold tabular-nums">{count}</span>
      {tail}
    </>
  );
}
